
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import blogData from "../blogData.json";
import blogBg from "../../../assests/blog/angu (1).png";

const DelayedRecruitment = () => {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <div className="mx-auto px-4 py-12">
      {/* Relative wrapper for positioning */}
      <div className="relative w-full h-[400px] mb-6">
        <img
          src={blogBg}
          className="w-full h-full object-cover opacity-90 rounded-lg"
          alt="Blog Background"
        />

        {/* Centered Text */}
        <div className="absolute inset-0 flex items-center justify-center px-4">
          <h1 className="text-center text-[45px] lg:text-4xl font-recoleta text-white max-w-3xl">
          How to limit the damages of the delayed recruitment process with help of strategic staffing solutions?
          </h1>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4">
        <div className="text-left">
          <div className="h-20 border-l-2 px-8 border-blue-600">
            <h1 className="font-bold text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">
            How to limit the damages of the delayed recruitment process with help of strategic staffing solutions?
            </h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Staffing management methods originated to help companies spot and acquire the employees they need in all sections and departments. Ideally, this method will recognize the company's needs in multiple ways, depending upon its formation and business model.
          Previously the layout of the companies was the finance team with the human resource team and the marketing and sales group. These three sections again had subsections where the work got divided. Every organization more or less had this in-house team.
          </p>
       
        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Damages with Conventional Staffing Solutions Services</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          However, some business analysts developed a viewpoint of the damage these organizations have borne because of such conventional staffing. The damages that they identify are -

          </p>

        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">HR recruitment</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Before recruiting other employees, they have to find the perfect HR for the company. That was a grueling process because India previously never had a great scope for HRs. So limited people in India took it as a profession.

          </p>

        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Not so cost-effective model</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Like the fact that the availability of HR in India was rare, whoever became one came with a tremendous cost for the organization. As a result, building up an HR team became a costly event.

          </p>

        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Not finding the right talent</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          It was seen that many HRs in the company failed to identify the right talent though this position comes with a high cost in the market. So the conventional HR team-building model was unable to prove cost-effective. For the last 12-15 years, this scenario has been a noticeable change from this unoriginal system in the companies. The last decade was of MSMEs and startups, and these startups do not have enough resources to follow the conventional method of having separate teams for separate departments. This is because they are high on targets and minimal on resources. Their main aim is to generate revenue to sustain in the market. In that process, they look for quick services with fewer funds.

          </p>

        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Why Strategic Staffing Solutions?</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          A new channel opened in the industry with HR services offered to such companies as per the market demand. Strategic staffing solutions deploy in-demand talent and professionals from agile regions and supply them to markets, and that is precisely what Tekit has been doing for half a decade.
          TekIT, a staffing solution service provider, has its headquarters in the USA with centers in Madhya Pradesh, having the pleasure and mission to help companies. To expand and grow their hiring process by the cream selection of top talent. TekIT's growth is directly proportional to the development of our clients. So we try to give the best of the services and resources available in the market. TekIT is a customer-oriented, full-service IT firm serving hundreds of clients for many years, both nationally and internationally, helping them grow since its early constitution.
          </p>

        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">High targets, fewer resources?</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Strategic staffing solution services by TekIT From contractual freelancer staffing to permanent, long-term staffing, TekIT's staffing plan showed its mark in the industry within no time. It is our dynamic and client-centric approach that is making us one of a kind in the market. We can arrange Staffing solution resources for a short span for our clients and also acquire candidates who will be looking for long-term engagement by meticulously reviewing their educational qualifications, experience, conduct, and wisdom. Again, the startups do not have enough resources to follow the conventional system of having separate teams for separate departments. So they look for new, young, contingent talent to have cost-effective alternatives and meet the business demand. This is precisely where TekIT's staffing plan has become a pro.
          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-20 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Other Services Offered by TekIT Solutions</h1>
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-3">Offshore development center</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          We provide staffing solution services overseas to the corporation. Our offshore staffing service solution provides the option to retain control in the daily operation despite the difference in time and location. It provides a cost-effective model for the organization.
          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Web development</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Want to have a next-level digital storefront? TekIT is what you are looking for. Seeing the ever-increasing market demand, we bring you TekIT, the ultimate platform for your business to go digital. Professionals will meticulously craft to give that much-needed hike to your perfectly suited business.
          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Mobile app development</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Marketing is no longer confined to the concept of posting posters, distributing free samples, TV advertisements, or becoming the sponsor for a big event. It's more than that now. With digitalization, the marketing concept also got merged with it, and we got a new component: digital marketing. Engaging customers in the digital platform can bring brand awareness at a lower cost. So apart from website development, TekIT also targeted developing mobile apps for companies as another component of digital marketing. Slay with TekIT in the market with IOS, Android, and other web apps.

          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Enterprise software</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          TekIT understands and builds software for different companies, which will give a much-needed upgrade and business efficiency. Our services in this section include API integration, automated business processes, and improving and supporting business infrastructure per market demand.

          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Digital marketing services</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          TekIT identifies how digitally oriented people are becoming. The goal should be to make a productive place from that time that people are investing online. TekIT also caters to companies in the field of digital marketing. TekIT offers services like search engine optimization (SEO), content marketing, social media marketing, online PR, marketing, search engine marketing, graphic design, etc.
          </p>
        </div>
        <div className="text-left">
          <div className="font-bold h-12 border-l-2 px-8 border-blue-600">
            <h1 className=" text-[34px] lg:text-[22px] 2xl:text-[30px] font-recoleta mt-12">Managed services</h1>
          </div>
          <p className="lg:text-[14px] 2xl:text-[20px] px-3 text-[28px] mt-20 lg:mt-12">
          Staffing services are a great way to find good quality employees without the hassles of trying to recruit.
When you use staffing services, you can choose from various staffing solutions. Choose the best choice for your business and your employees' requirements and demands. TekIT Solutions helps business clients meet their staffing demands by supplying competent and pre-screened contractual or temporary human resources.
Our IT staffing services are tailored to match your specific requirements. We promise that we will provide lucrative solutions for your personnel requirements
          </p>
        </div>


      </div>

    </div>
  );
};

export default DelayedRecruitment;
